import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { PasswordReusableInput } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import {
  BackButtonIcon,
  BackLogoIconButton,
  LoginTopLogoAndText,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { forgot_new_password } from "../../../store/actions/authAction";
import { ResetPasswordValidation } from "../../../store/validation/allValidationFile/authenticationValidation/ResetPasswordValidation";
// import isEmpty from "../../../store/validation/is-Empty";

const strongRegex = new RegExp(
  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,32}$/
);

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: false,
      mobile_number: "",
      password: "",
      confirm_password: "",
      passwordIcon: true,
      slashEyeIcon: false,
      loading: false,
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "password" &&
      !strongRegex.test(e.target.value)
    ) {
      errors[
        e.target.name
      ] = `Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      // case "password":
      //   errors.password =
      //     value.length < 6 ? "Password must contain atleast 6 characters" : "";
      //   break;
      case "password":
        errors.password = strongRegex.test(value)
          ? ""
          : "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.";
        break;
      case "confirm_password":
        errors.confirm_password =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleClickShowPassword = (e) => {
    this.setState({
      view: !this.state.view,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = ResetPasswordValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const token = this.props.location.state.formData.token;
      const formData = {
        mobile_number: this.props.location.state.formData.formData,
        country_code: this.props.location.state.formData.country_code,
        password: this.state.password,
        strategy: "vendor-user",
      };
      this.props.forgot_new_password(formData, token, this.props.history);
    }
  };

  render() {
    const { password, confirm_password, loading, errors } = this.state;
    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            {/* <BackButtonIcon linkPath="/otp" /> */}
            <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
              <div className="col-12 display-top-header-mobile">
                <BackLogoIconButton
                  displayHelpImage={true}
                  displayArrow={true}
                  displayBackText="Back"
                  backButtonClicked="/forgotpassword"
                  notDisplaProgressBar={true}
                />
              </div>
              <div className="col-12 loginsignup-section">
                <LoginTopLogoAndText
                  bigText="Reset Password"
                  smallText="Type and confirm a secure new password for the account"
                />
              </div>
              <Col className="login-section-margin">
                {/* <LoginTopLogoAndText display={true} bigText="Reset Password" /> */}
                <Form noValidate onSubmit={this.handleSubmit}>
                  <PasswordReusableInput
                    onKeyPress={(event) => {
                      if (!/^\S*$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    extraClass="mt-4 w-100"
                    labelText="Enter New Password"
                    inputTypeState={this.state.view}
                    value={this.state.password}
                    name="password"
                    onFocusOut={this.onFocusOut}
                    handleChange={this.handleChange}
                    handleClickShowPassword={this.handleClickShowPassword}
                    handleMouseDownPassword={this.handleMouseDownPassword}
                    errorText={errors.password}
                    errorTrue={
                      // errors.password === "password is required" ? true : false
                      errors.password === "password is Required" ||
                      errors.password === "password is required" ||
                      errors.password ===
                        "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                        ? // (this.state.password.length > 0 &&
                          //   this.state.password.length < 6)
                          true
                        : false
                    }
                    wLabel={160}
                  />
                  <PasswordReusableInput
                    onKeyPress={(event) => {
                      if (!/^\S*$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    extraClass="mt-4 w-100"
                    labelText="Confirm Password"
                    inputTypeState={this.state.view}
                    value={this.state.confirm_password}
                    name="confirm_password"
                    onFocusOut={this.onFocusOut}
                    handleChange={this.handleChange}
                    handleClickShowPassword={this.handleClickShowPassword}
                    handleMouseDownPassword={this.handleMouseDownPassword}
                    errorText={
                      this.state.confirm_password.length === 0
                        ? errors.confirm_password
                        : "Password and Confirm Password do not match" &&
                          this.state.password !== this.state.confirm_password
                        ? "Password and Confirm Password do not match"
                        : ""
                    }
                    errorTrue={
                      this.state.confirm_password.length === 0
                        ? errors.confirm_password
                        : "Password and Confirm Password do not match" &&
                          this.state.password !== this.state.confirm_password
                    }
                    wLabel={140}
                  />
                  {/* <InputBoxComponent
                    displayLabel={true}
                    passwordIcon={passwordIcon}
                    slashEyeIcon={slashEyeIcon}
                    controlId="New Password"
                    labelText="Enter New Password"
                    inputType={!this.state.view ? "password" : "text"}
                    placeHolder="*******"
                    name="password"
                    onChange={this.handleChange}
                    onFocusOut={this.onFocusOut}
                    value={this.state.password}
                    required="required"
                    passwordShow={this.onPasswordChange}
                    passwordHide={this.onPasswordHide}
                    showBottom={true}
                    error={
                      (this.state.password > 0 && errors.password) ||
                      errors.password
                    }
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.password,
                    })}
                  />
                  <InputBoxComponent
                    displayLabel={true}
                    passwordIcon={passwordIcon}
                    slashEyeIcon={slashEyeIcon}
                    controlId="Confirm Password"
                    labelText="Confirm Password"
                    inputType={!this.state.view ? "password" : "text"}
                    placeHolder="*******"
                    name="confirm_password"
                    onChange={this.handleChange}
                    onFocusOut={this.onFocusOut}
                    value={this.state.confirm_password}
                    required="required"
                    passwordShow={this.onPasswordChange}
                    passwordHide={this.onPasswordHide}
                    showBottom={true}
                    error={
                      this.state.confirm_password.length === 0
                        ? errors.confirm_password
                        : "Password and Confirm Password do not match" &&
                          this.state.password !== this.state.confirm_password
                        ? "Password and Confirm Password do not match"
                        : ""
                    }
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.confirm_password,
                    })}
                  /> */}
                  <Col className="send-otp-top-margin-reset">
                    <ButtonReusableComponent
                      buttonText="Submit"
                      buttonType={
                        password.length <= 0 ||
                        confirm_password.length <= 0 ||
                        password !== confirm_password ||
                        errors.password ===
                          "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                          ? "button"
                          : "submit"
                      }
                      buttonClass={
                        password.length <= 0 ||
                        confirm_password.length <= 0 ||
                        password !== confirm_password ||
                        errors.password ===
                          "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                          ? "login"
                          : "activeLogin"
                      }
                      disabled={
                        password.length <= 0 ||
                        confirm_password.length <= 0 ||
                        password !== confirm_password ||
                        errors.password ===
                          "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                          ? true
                          : false
                      }
                    />
                  </Col>
                </Form>
              </Col>
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

ResetPassword.propTypes = {
  forgot_new_password: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  forgot_new_password,
})(withRouter(ResetPassword));
